import { BePlannedMonthlyV2 } from "./BePlannedMonthlyV2";

export default BePlannedMonthlyV2;
